import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function AirportsTeamPage() {
  return (
    <SoftBox py={3}>
      <SoftTypography variant="h4" fontWeight="bold" gutterBottom>
        Airports Team
      </SoftTypography>
      <SoftTypography variant="body2" color="text">
        Placeholder team management view for airport portal users.
      </SoftTypography>
    </SoftBox>
  );
}

export default AirportsTeamPage;


